import { fromJS, Map, List } from 'immutable'
import {
  createAmbassador,
  createAmbassadorCampaign,
  updateAmbassador,
  createAmbassadorListViewOptions,
  createAmbassadorPayoutsPageOptions,
  getAmbassador,
  getAmbassadorPayout,
  getAmbassadorPayouts,
  getAmbassadorSignups,
  getAmbassadorHistory,
  getAmbassadorAdmins,
  getAmbassadorConversions,
  getAmbassadorRelationshipOwners,
  createAmbassadorSignupOptions,
  createAmbassadorConversionsOptions,
  createAmbassadorPayoutViewOptions,
  getAmbassadorPayoutTotals,
  getAmbassadorList,
  isAmbassadorListPage,
  isAmbassadorDetailPage,
  isAmbassadorPayoutsPage,
  AMBASSADOR_STORE_KEY,
  AMBASSADOR_PAYOUT_STORE_KEY,
  AMBASSADOR_ADMIN_STORE_KEY,
  AMBASSADOR_CONVERSIONS_STORE_KEY,
  AMBASSADOR_RELATIONSHIP_OWNER_STORE_KEY,
  AMBASSADOR_HISTORY_STORE_KEY,
  AMBASSADOR_PAYOUTS_STORE_KEY,
  AMBASSADOR_SIGNUPS_STORE_KEY,
  AMBASSADOR_CREATE_APPLICATION_KEY,
  AMBASSADOR_UPDATE_APPLICATION_KEY,
  AMBASSADOR_USER_SEARCH_APPLICATION_KEY,
  AMBASSADOR_PARENT_APPLICATION_KEY,
  AMBASSADOR_PAYOUT_TOTALS_APPLICATION_KEY,
  AMBASSADOR_PAYOUTS_CSV_APPLICATION_KEY,
  AMBASSADOR_LIST_CSV_APPLICATION_KEY,
  AMBASSADOR_SIGNUPS_CSV_APPLICATION_KEY,
  AMBASSADOR_CONVERSIONS_CSV_APPLICATION_KEY,
  AMBASSADOR_PARTNER_OPTIONS_KEY,
  AMBASSADOR_FIELD_NAME,
  AMBASSADOR_MAX_CSV_RECORDS,
  AMBASSADOR_CSV_BATCH_SIZE,
  AMBASSADOR_CAMPAIGNS_TAB,
  AMBASSADOR_CAMPAIGNS_STORE_KEY,
  createAmbassadorCampaignsOptions,
  getAmbassadorCampaignsMetrics,
  getAmbassadorCampaignDetails,
  isAmbassadorCampaignDetailPage,
  AMBASSADOR_CAMPAIGN_DETAILS_STORE_KEY,
  isAmbassadorCampaignMetricsPage,
  LEADS_TAB,
  AMBASSADOR_LEADS_STORE_KEY,
  createAmbassadorLeadsViewOptions,
  getAmbassadorLeads,
  isLeadsTab,
  AMBASSADOR_LEADS_CSV_APPLICATION_KEY,
  LEAD_FIELD_NAME,
  LEAD_REFERRING_PARTNER,
  LEAD_CAPTURE_DATE,
  LEAD_CONVERTED,
  LEAD_CONVERSION_DATE,
  LEAD_CAMPAIGN,
  CAMPAIGN_CREATE_APPLICATION_KEY,
  CAMPAIGN_UPDATE_APPLICATION_KEY,
  CAMPAIGN_STORE_KEY,
  SIGNUPS_TAB,
  isSignupsTab,
  BILLINGS_TAB,
  isBillingsTab,
  updateAmbassadorCampaign,
  currentYear,
  CAMPAIGN_PARTNERS_TAB,
} from 'services/ambassador'
import {
  CREATE_AMBASSADOR,
  UPDATE_AMBASSADOR,
  GET_AMBASSADOR_USER_DATA,
  GET_AMBASSADOR_BY_UTM,
  getAmbassadorHistoryData,
  GET_AMBASSADOR_HISTORY_DATA,
  EXPORT_AMBASSADORS_PAYOUT_CSV,
  EXPORT_AMBASSADOR_LIST_CSV,
  EXPORT_AMBASSADOR_SIGNUPS_CSV,
  EXPORT_AMBASSADOR_CONVERSIONS_CSV,
  EXPORT_AMBASSADOR_LEADS_CSV,
  CREATE_CAMPAIGN,
  UPDATE_CAMPAIGN,
  GET_ALL_AMBASSADORS_DATA,
  GET_CAMPAIGN_DETAIL_DATA,
  getCampaignDetailData,
} from 'services/ambassador/redux/actions'
import { DISMISS_MODAL, dismissModal } from 'services/modal/redux/actions'
import { AMBASSADOR_FORM_MODAL } from 'services/modal'
import { reduce as BluebirdReduce } from 'bluebird'
import {
  getDataList as getDataListAction,
  setDataList as setDataListAction,
  setDataApplicationByKey,
  deleteDataApplication,
  GET_DATA_LIST,
  SET_DATA_APPLICATION_BY_KEY,
} from 'services/data/redux/actions'
import { SET_PAGE_READY } from 'services/pages/redux/actions'
import { isLoggedIn } from 'services/auth'
import { SET_AUTH_DATA } from 'services/auth/redux/actions'
import { isPageReady } from 'services/pages'
import { formatUTC, formatWrapped } from 'services/date'
import { SET_LOCATION_DATA } from 'services/location/redux/actions'
import {
  findView,
  createViewRecords,
  getApplicationDataByKey,
  sortASC,
  sortDESC,
} from 'services/data'
import { getConfigDataServer } from 'services/config'
import { searchUsersByQuery } from 'services/user'
import { exportCSVFile, stripComma, getCSVNumberValue } from 'services/file'
import { parseISO } from 'date-fns'
import { SORT_ORDER_ASC } from 'services/constants'
import _range from 'lodash/range'
import { formatInTimeZone } from 'date-fns-tz'
import { showErrorToast, showSuccessToast } from 'services/toast/redux/actions'
import { getFirstErrorMessage } from 'services/error'

const log = console

/**
 * Returns true if the action has a storeKey of 'ambassador'
 * @param {Object} options The parameters
 * @param {Object} [options.action={}] A redux action
 * @param {Object} [options.action.payload] The action payload
 * @param {String} [options.action.payload.storeKey] The store key
 * @returns {Boolean} True when store key equals ambassador
 */
function isAmbassadorDataAction (options = {}) {
  const { action = {} } = options
  const { payload: { storeKey } = {} } = action

  return storeKey === AMBASSADOR_STORE_KEY
}

/**
 * Returns true if the action has a storeKey of 'ambassadorPayout'
 * @param {Object} options The parameters
 * @param {Object} [options.action={}] A redux action
 * @param {Object} [options.action.payload] The action payload
 * @param {String} [options.action.payload.storeKey] The store key
 * @returns {Boolean} True when store key equals ambassadorPayout
 */
function isAmbassadorPayoutDataAction (options = {}) {
  const { action = {} } = options
  const { payload: { storeKey } = {} } = action

  return storeKey === AMBASSADOR_PAYOUT_STORE_KEY
}

/**
 * Returns true if the action has a storeKey of 'ambassador'
 * @param {Object} options The parameters
 * @param {Object} [options.action={}] A redux action
 * @param {Object} [options.action.payload] The action payload
 * @param {String} [options.action.payload.storeKey] The store key
 * @returns {Boolean} True when store key equals ambassadorPayout
 */
function isAmbassadorHistoryDataAction (options = {}) {
  const { action = {} } = options
  const { payload: { storeKey } = {} } = action

  return storeKey === AMBASSADOR_HISTORY_STORE_KEY
}

/**
 * Returns true if the action has a storeKey of 'ambassadorAdmin'
 * @param {Object} options The parameters
 * @param {Object} [options.action={}] A redux action
 * @param {Object} [options.action.payload] The action payload
 * @param {String} [options.action.payload.storeKey] The store key
 * @returns {Boolean} True when store key equals ambassador
 */
function isAmbassadorAdminAction (options = {}) {
  const { action = {} } = options
  const { payload: { storeKey } = {} } = action

  return storeKey === AMBASSADOR_ADMIN_STORE_KEY
}

/**
 * Returns true if the action has a storeKey of 'ambassadorRelationshipOwner'
 * @param {Object} options The parameters
 * @param {Object} [options.action={}] A redux action
 * @param {Object} [options.action.payload] The action payload
 * @param {String} [options.action.payload.storeKey] The store key
 * @returns {Boolean} True when store key equals ambassador
 */
function isAmbassadorRelationshipOwnerAction (options = {}) {
  const { action = {} } = options
  const { payload: { storeKey } = {} } = action
  return storeKey === AMBASSADOR_RELATIONSHIP_OWNER_STORE_KEY
}

/**
 * Determines if action is using ambassador payouts store key
 * @param {Object} options The parameters
 * @param {Object} [options.action={}] A redux action
 * @param {Object} [options.action.payload] The action payload
 * @param {String} [options.action.payload.storeKey] The store key
 * @returns {Boolean} True when store key equals ambassadorPayout
 */
function isAmbassadorPayoutsDataAction (options = {}) {
  const { action = {} } = options
  const { payload: { storeKey } = {} } = action

  return storeKey === AMBASSADOR_PAYOUTS_STORE_KEY
}

/**
 * Determines if action is using ambassador signup store key
 * @param {Object} options The parameters
 * @param {Object} [options.action={}] A redux action
 * @param {Object} [options.action.payload] The action payload
 * @param {String} [options.action.payload.storeKey] The store key
 * @returns {Boolean} True when store key equals ambassadorPayout
 */
function isAmbassadorSignupsDataAction (options = {}) {
  const { action = {} } = options
  const { payload: { storeKey } = {} } = action
  return storeKey === AMBASSADOR_SIGNUPS_STORE_KEY
}

function isLeadsDataAction (options = {}) {
  const { action = {} } = options
  const { payload: { storeKey } = {} } = action
  return storeKey === AMBASSADOR_LEADS_STORE_KEY
}

/**
 * Determines if action is using ambassador conversions store key
 * @param {Object} options The parameters
 * @param {Object} [options.action={}] A redux action
 * @param {Object} [options.action.payload] The action payload
 * @param {String} [options.action.payload.storeKey] The store key
 * @returns {Boolean} True when store key equals ambassadorPayout
 */
function isAmbassadorConversionsDataAction (options = {}) {
  const { action = {} } = options
  const { payload: { storeKey } = {} } = action
  return storeKey === AMBASSADOR_CONVERSIONS_STORE_KEY
}

/**
 * Returns true if the action has a storeKey of 'ambassador' and application key equals create
 * @param {Object} options The parameters
 * @param {Object} [options.action={}] A redux action
 * @param {Object} [options.action.payload] The action payload
 * @param {String} [options.action.payload.storeKey] The store key
 * @param {String} [options.action.payload.applicationKey] The application store key
 * @param {Map} [options.action.payload.applicationData] The application data
 * @returns {Boolean} True when store key equals ambassador and application key equals create
 * and there is a uuid returned in the applicaiton data
 */
function isAmbassadorSuccessfulCreate (options = {}) {
  const { action = {} } = options
  const { payload: { storeKey, applicationKey, applicationData } = {} } = action
  const ambassadorUuid = applicationData.getIn(['data', 'uuid'])

  return (
    storeKey === AMBASSADOR_STORE_KEY &&
    applicationKey === AMBASSADOR_CREATE_APPLICATION_KEY &&
    ambassadorUuid
  )
}

/**
 * Determines if an ambassador was successfully updated
 * @param {Object} options The parameters
 * @param {Object} [options.action={}] A redux action
 * @param {Object} [options.action.payload] The action payload
 * @param {String} [options.action.payload.storeKey] The store key
 * @param {String} [options.action.payload.applicationKey] The application store key
 * @param {Map} [options.action.payload.applicationData] The application data
 * @returns {Boolean} True when store key equals ambassador and application key equals update
 * and there is a uuid returned in the applicaiton data
 */
function isAmbassadorSuccessfulUpdate (options = {}) {
  const { action = {} } = options
  const { payload: { storeKey, applicationKey, applicationData } = {} } = action
  const ambassadorUuid = applicationData.getIn(['data', 'uuid'])

  return (
    storeKey === AMBASSADOR_STORE_KEY &&
    applicationKey === AMBASSADOR_UPDATE_APPLICATION_KEY &&
    ambassadorUuid
  )
}

/**
 * Watcher to get user data.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness take every function
 */
export function watchGetAmbassadorUserData ({ after } = {}) {
  return after(GET_AMBASSADOR_USER_DATA, async ({ state, action, dispatch }) => {
    const { config, auth } = state
    const { payload } = action
    const server = config.getIn(['data', 'servers', 'auth'])
    if (!auth.getIn(['data', 'jwt']) || !server) {
      return
    }

    try {
      dispatch(
        setDataApplicationByKey({
          storeKey: AMBASSADOR_STORE_KEY,
          applicationData: fromJS({ processing: true }),
          applicationKey: AMBASSADOR_USER_SEARCH_APPLICATION_KEY,
        }),
      )
      const data = await searchUsersByQuery({ auth, server, email: payload })
      dispatch(
        setDataApplicationByKey({
          storeKey: AMBASSADOR_STORE_KEY,
          applicationData: fromJS({ processing: false, data }),
          applicationKey: AMBASSADOR_USER_SEARCH_APPLICATION_KEY,
        }),
      )
    } catch (error) {
      dispatch(
        setDataApplicationByKey({
          storeKey: AMBASSADOR_STORE_KEY,
          applicationData: fromJS({ processing: false, data: {}, error: true }),
          applicationKey: AMBASSADOR_USER_SEARCH_APPLICATION_KEY,
        }),
      )
    }
  })
}

/**
 * Watcher to get an ambassador by utm.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness take every function
 */
export function watchGetAmbassadorByUtm ({ after } = {}) {
  return after(GET_AMBASSADOR_BY_UTM, async ({ state, action, dispatch }) => {
    const { config, auth } = state
    const { payload } = action
    const server = config.getIn(['data', 'servers', 'auth'])
    if (!auth.getIn(['data', 'jwt']) || !server) {
      return
    }

    try {
      dispatch(
        setDataApplicationByKey({
          storeKey: AMBASSADOR_STORE_KEY,
          applicationData: fromJS({ processing: true }),
          applicationKey: AMBASSADOR_PARENT_APPLICATION_KEY,
        }),
      )
      const data = await getAmbassadorList({
        auth,
        server: getConfigDataServer(config),
        utmMedium: payload,
      })
      let exactData = data
      if (data.get('ambassadors').size > 0) {
        const ambassadors = List().push(
          data.get('ambassadors').find((a) => a.get('utmMedium') === payload),
        )
        // we are using the endpoint that filters utms 'like' this one so must find exact match
        exactData = data.set('ambassadors', ambassadors)
      }
      dispatch(
        setDataApplicationByKey({
          storeKey: AMBASSADOR_STORE_KEY,
          applicationData: fromJS({ processing: false, data: exactData }),
          applicationKey: AMBASSADOR_PARENT_APPLICATION_KEY,
        }),
      )
    } catch (error) {
      dispatch(
        setDataApplicationByKey({
          storeKey: AMBASSADOR_STORE_KEY,
          applicationData: fromJS({ processing: false, data: {}, error: true }),
          applicationKey: AMBASSADOR_PARENT_APPLICATION_KEY,
        }),
      )
    }
  })
}

/**
 * Watcher to create a new Ambassador.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness take every function
 */
export function watchCreateAmbassador ({ after } = {}) {
  return after(CREATE_AMBASSADOR, async ({ state, action, dispatch }) => {
    const { config, auth } = state
    const server = config.getIn(['data', 'servers', 'brooklyn'])
    if (!auth.getIn(['data', 'jwt']) || !server) {
      return
    }

    dispatch(
      setDataApplicationByKey({
        storeKey: AMBASSADOR_STORE_KEY,
        applicationData: fromJS({ processing: true }),
        applicationKey: AMBASSADOR_CREATE_APPLICATION_KEY,
      }),
    )
    let closeModal = true

    try {
      const body = {
        ...action.payload,
      }
      const options = { auth, server, body }
      const data = await createAmbassador(options)
      dispatch(
        setDataApplicationByKey({
          storeKey: AMBASSADOR_STORE_KEY,
          applicationData: fromJS({ processing: false, data }),
          applicationKey: AMBASSADOR_CREATE_APPLICATION_KEY,
        }),
      )
    } catch (error) {
      log.warn(error, 'Error creating new ambassador')
      dispatch(
        setDataApplicationByKey({
          storeKey: AMBASSADOR_STORE_KEY,
          applicationData: fromJS({ processing: false, data: {}, error: true }),
          applicationKey: AMBASSADOR_CREATE_APPLICATION_KEY,
        }),
      )
      closeModal = false
    } finally {
      if (closeModal) {
        dispatch(dismissModal())
      }
    }
  })
}

/**
 * Watcher to create a new Campaign
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness take every function
 */
export function watchCreateCampaign ({ after } = {}) {
  return after(CREATE_CAMPAIGN, async ({ state, action, dispatch }) => {
    const { config, auth, location } = state
    const server = config.getIn(['data', 'servers', 'brooklyn'])
    if (!auth.getIn(['data', 'jwt']) || !server) {
      return
    }

    dispatch(
      setDataApplicationByKey({
        storeKey: CAMPAIGN_STORE_KEY,
        applicationData: fromJS({ processing: true }),
        applicationKey: CAMPAIGN_CREATE_APPLICATION_KEY,
      }),
    )

    try {
      const body = {
        ...action.payload,
      }
      const options = { auth, server, body }
      const data = await createAmbassadorCampaign(options)
      dispatch(
        setDataApplicationByKey({
          storeKey: CAMPAIGN_STORE_KEY,
          applicationData: fromJS({ processing: false, data }),
          applicationKey: CAMPAIGN_CREATE_APPLICATION_KEY,
        }),
      )
      dispatch(
        getDataListAction({
          storeKey: AMBASSADOR_CAMPAIGNS_STORE_KEY,
          options: createAmbassadorCampaignsOptions({ location }),
          processing: true,
          total: 0,
        }),
      )
      dispatch(showSuccessToast('New Campaign was created'))
      dispatch(dismissModal())
    } catch (error) {
      log.warn(error, 'Error creating new campaign')
      dispatch(showErrorToast(getFirstErrorMessage(error)))
      dispatch(
        setDataApplicationByKey({
          storeKey: CAMPAIGN_STORE_KEY,
          applicationData: fromJS({ processing: false, data: {}, error: true }),
          applicationKey: CAMPAIGN_CREATE_APPLICATION_KEY,
        }),
      )
    }
  })
}

/**
 * Watcher to update a Campaign
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness take every function
 */
export function watchUpdateCampaign ({ after } = {}) {
  return after(UPDATE_CAMPAIGN, async ({ state, action, dispatch }) => {
    const { config, auth } = state
    const server = config.getIn(['data', 'servers', 'brooklyn'])
    if (!auth.getIn(['data', 'jwt']) || !server) {
      return
    }

    dispatch(
      setDataApplicationByKey({
        storeKey: CAMPAIGN_STORE_KEY,
        applicationData: fromJS({ processing: true }),
        applicationKey: CAMPAIGN_UPDATE_APPLICATION_KEY,
      }),
    )

    try {
      const body = {
        ...action.payload,
      }
      const options = { auth, server, body }
      const data = await updateAmbassadorCampaign(options)
      dispatch(
        setDataApplicationByKey({
          storeKey: CAMPAIGN_STORE_KEY,
          applicationData: fromJS({ processing: false, data }),
          applicationKey: CAMPAIGN_UPDATE_APPLICATION_KEY,
        }),
      )
      dispatch(getCampaignDetailData())
      dispatch(showSuccessToast('New Campaign was updated'))
      dispatch(dismissModal())
    } catch (error) {
      log.warn(error, 'Error updating campaign')
      dispatch(showErrorToast(getFirstErrorMessage(error)))
      dispatch(
        setDataApplicationByKey({
          storeKey: CAMPAIGN_STORE_KEY,
          applicationData: fromJS({ processing: false, data: {}, error: true }),
          applicationKey: CAMPAIGN_UPDATE_APPLICATION_KEY,
        }),
      )
    }
  })
}

export function watchCreateAmbassadorSuccess ({ after }) {
  return after(SET_DATA_APPLICATION_BY_KEY, async ({ state, dispatch }) => {
    const storeKey = AMBASSADOR_STORE_KEY
    const options = createAmbassadorListViewOptions(state)

    dispatch(
      getDataListAction({
        storeKey,
        options,
      }),
    )
  }).when(
    ({ state, action }) => isAmbassadorSuccessfulCreate({ action }) && isAmbassadorListPage(state),
  )
}

/**
 * Reset the the Ambassador error when the modal is closed.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.before The witness take every function
 */
export function watchDismissCreateAmbassadorModal ({ before } = {}) {
  return before(DISMISS_MODAL, async ({ state, dispatch }) => {
    const { modal } = state

    if (modal && modal.get('componentName') === AMBASSADOR_FORM_MODAL) {
      dispatch(
        deleteDataApplication({
          storeKey: AMBASSADOR_STORE_KEY,
        }),
      )
    }
  })
}

/**
 * Watcher for updating Ambassador.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness take every function
 */
export function watchUpdateAmbassador ({ after } = {}) {
  return after(UPDATE_AMBASSADOR, async ({ state, action, dispatch }) => {
    const { config, auth } = state
    const server = config.getIn(['data', 'servers', 'brooklyn'])
    if (!auth.getIn(['data', 'jwt']) || !server) {
      return
    }

    dispatch(
      setDataApplicationByKey({
        storeKey: AMBASSADOR_STORE_KEY,
        applicationData: fromJS({ processing: true }),
        applicationKey: AMBASSADOR_UPDATE_APPLICATION_KEY,
      }),
    )
    let closeModal = true

    try {
      const body = {
        ...action.payload.values,
      }
      const { uuid } = action.payload
      const options = {
        auth,
        server,
        body,
        uuid,
      }
      const data = await updateAmbassador(options)
      dispatch(
        setDataApplicationByKey({
          storeKey: AMBASSADOR_STORE_KEY,
          applicationData: fromJS({ processing: false, data }),
          applicationKey: AMBASSADOR_UPDATE_APPLICATION_KEY,
        }),
      )
    } catch (error) {
      log.warn(error, 'Error updating ambassador')
      dispatch(
        setDataApplicationByKey({
          storeKey: AMBASSADOR_STORE_KEY,
          applicationData: fromJS({ processing: false, data: {}, error: true }),
          applicationKey: AMBASSADOR_UPDATE_APPLICATION_KEY,
        }),
      )
      closeModal = false
    } finally {
      if (closeModal) {
        dispatch(dismissModal())
      }
    }
  })
}

export function watchUpdateAmbassadorSuccess ({ after }) {
  return after(SET_DATA_APPLICATION_BY_KEY, async ({ state, dispatch }) => {
    const { data } = state
    const storeKey = AMBASSADOR_STORE_KEY
    const ambassadorUpdateData =
      getApplicationDataByKey({
        data,
        storeKey: AMBASSADOR_STORE_KEY,
        applicationKey: AMBASSADOR_UPDATE_APPLICATION_KEY,
      }) || Map()

    dispatch(
      getDataListAction({
        storeKey,
        options: {
          uuid: ambassadorUpdateData.getIn(['data', 'uuid']),
        },
      }),
    )
  }).when(
    ({ state, action }) =>
      isAmbassadorSuccessfulUpdate({ action }) && isAmbassadorDetailPage(state),
  )
}

const dispatchSignups = (state, dispatch) => {
  const { data, location } = state
  const tab = location.getIn(['data', 'query', 'tab'])

  const options = createAmbassadorSignupOptions({ location })
  const storeKey = AMBASSADOR_SIGNUPS_STORE_KEY

  const signupsView = findView({
    options,
    storeKey,
    data,
  })

  if (!signupsView && tab === SIGNUPS_TAB) {
    dispatch(
      getDataListAction({
        options,
        storeKey,
        processing: true,
        total: 0,
      }),
    )
  }
}

const dispatchBillings = (state, dispatch) => {
  const { data, location } = state
  const tab = location.getIn(['data', 'query', 'tab'])

  const options = createAmbassadorConversionsOptions({ location })
  const storeKey = AMBASSADOR_CONVERSIONS_STORE_KEY

  const conversionsView = findView({
    options,
    storeKey,
    data,
  })

  if (!conversionsView && tab === BILLINGS_TAB) {
    dispatch(
      getDataListAction({
        options,
        storeKey,
        processing: true,
        total: 0,
      }),
    )
  }
}

const dispatchLeads = (state, dispatch) => {
  const { data, location } = state
  const tab = location.getIn(['data', 'query', 'tab'])

  const options = createAmbassadorLeadsViewOptions({ location })
  const storeKey = AMBASSADOR_LEADS_STORE_KEY

  const leadsView = findView({
    options,
    storeKey,
    data,
  })

  if (!leadsView && tab === LEADS_TAB) {
    dispatch(
      getDataListAction({
        options,
        storeKey,
        processing: true,
        total: 0,
      }),
    )
  }
}

// ------------------------
// List Page
// ------------------------
export function initAmbassadorListPage ({ after }) {
  return after(
    [SET_AUTH_DATA, SET_PAGE_READY, SET_LOCATION_DATA],
    ({ state, prevState, dispatch }) => {
      const { data, location } = state
      const storeKey = AMBASSADOR_STORE_KEY
      const options = createAmbassadorListViewOptions(state)
      const prevOptions = createAmbassadorListViewOptions(prevState)
      const view = findView({ data, storeKey, options })
      const ambassadorsReady = view && options.equals(prevOptions)
      const adminsReady = data.get(AMBASSADOR_ADMIN_STORE_KEY)
      const tab = location.getIn(['data', 'query', 'tab'])
      if (!ambassadorsReady && tab === 'ambassadors') {
        dispatch(
          getDataListAction({
            storeKey,
            options,
          }),
        )
        dispatch(
          getDataListAction({
            storeKey: AMBASSADOR_RELATIONSHIP_OWNER_STORE_KEY,
            options: {},
          }),
        )
      }

      if (!adminsReady) {
        dispatch(
          getDataListAction({
            storeKey: AMBASSADOR_ADMIN_STORE_KEY,
            options: {},
          }),
        )
      }

      if (!tab || tab === AMBASSADOR_CAMPAIGNS_TAB) {
        dispatch(
          getDataListAction({
            storeKey: AMBASSADOR_CAMPAIGNS_STORE_KEY,
            options: createAmbassadorCampaignsOptions({ location }),
            processing: true,
            total: 0,
          }),
        )
      }

      dispatchSignups(state, dispatch)
      dispatchBillings(state, dispatch)
      dispatchLeads(state, dispatch)
    },
  ).when(({ state }) => {
    const { auth, page } = state
    return isLoggedIn(auth) && isPageReady({ page }) && isAmbassadorListPage(state)
  })
}

export function getAmbassadorDataListContent ({ after }) {
  return after(GET_DATA_LIST, async ({ state, action, dispatch }) => {
    const { config, auth } = state
    const { storeKey, options } = action.payload
    try {
      const ambassadorList = await getAmbassadorList({
        auth,
        server: getConfigDataServer(config),
        page: options.get('page'),
        perPage: options.get('perPage'),
        sortField: options.get('sortField'),
        sortDirection: options.get('sortDirection'),
        name: options.get('name'),
        businessName: options.get('businessName'),
        utmMedium: options.get('utmMedium'),
        relationshipOwnerUuid: options.get('relationshipOwnerUuid'),
        parentUtm: options.get('parentUtm'),
        contactEmail: options.get('contactEmail'),
        gaiaEmail: options.get('gaiaEmail'),
        countAll: options.get('countAll'),
      })
      dispatch(
        setDataListAction({
          storeKey,
          options,
          records: createViewRecords(ambassadorList.get('ambassadors'), 'uuid'),
          total: ambassadorList.get('count'),
          processing: false,
        }),
      )
    } catch (e) {
      dispatch(
        setDataListAction({
          storeKey,
          options,
          processing: false,
          error: e,
        }),
      )
    }
  }).when(({ state, action }) => isAmbassadorDataAction({ action }) && isAmbassadorListPage(state))
}

export function getAmbassadorDataListContentAll ({ after }) {
  return after(GET_ALL_AMBASSADORS_DATA, async ({ state, action, dispatch }) => {
    const { config, auth } = state
    const { storeKey, options = {} } = action.payload
    try {
      const ambassadorList = await getAmbassadorList({
        auth,
        server: getConfigDataServer(config),
        perPage: options.perPage,
        sortField: options.sortField,
        sortDirection: options.sortDirection,
        activeOnly: options.activeOnly,
      })

      dispatch(
        setDataListAction({
          storeKey,
          options,
          records: createViewRecords(ambassadorList.get('ambassadors'), 'uuid'),
          total: ambassadorList.get('count'),
          processing: false,
        }),
      )
    } catch (e) {
      dispatch(
        setDataListAction({
          storeKey,
          options,
          processing: false,
          error: e,
        }),
      )
    }
  }).when(({ state }) => {
    const { data } = state
    const addPartnerOptions = !!data.get(AMBASSADOR_PARTNER_OPTIONS_KEY)

    return !addPartnerOptions
  })
}

// ------------------------
// Detail Page
// ------------------------
export function initAmbassadorDetailPage ({ after }) {
  return after([SET_AUTH_DATA, SET_PAGE_READY, SET_LOCATION_DATA], ({ state, dispatch }) => {
    const { data, location } = state

    const uuid = location.getIn(['data', 'query', 'uuid'])
    const tab = location.getIn(['data', 'query', 'tab']) || 'payouts'

    const payoutView = findView({
      options: createAmbassadorPayoutViewOptions({ location }),
      storeKey: AMBASSADOR_PAYOUT_STORE_KEY,
      data,
    })

    const campaignsView = findView({
      options: createAmbassadorCampaignsOptions({ location }),
      storeKey: AMBASSADOR_CAMPAIGNS_STORE_KEY,
      data,
    })

    // check for existing ambassador admin data
    if (!data.get(AMBASSADOR_ADMIN_STORE_KEY)) {
      dispatch(
        getDataListAction({
          storeKey: AMBASSADOR_ADMIN_STORE_KEY,
          options: {},
        }),
      )
    }
    // check for existing ambassador details data
    if (!data.getIn([AMBASSADOR_STORE_KEY, 'records', uuid])) {
      dispatch(
        getDataListAction({
          storeKey: AMBASSADOR_STORE_KEY,
          options: {
            uuid,
          },
        }),
      )
    }

    if (!payoutView && tab === 'payouts') {
      dispatch(
        getDataListAction({
          storeKey: AMBASSADOR_PAYOUT_STORE_KEY,
          options: createAmbassadorPayoutViewOptions({ location }),
        }),
      )
    }

    if (!campaignsView && tab === AMBASSADOR_CAMPAIGNS_TAB) {
      dispatch(
        getDataListAction({
          storeKey: AMBASSADOR_CAMPAIGNS_STORE_KEY,
          options: createAmbassadorCampaignsOptions({ location }),
          processing: true,
          total: 0,
        }),
      )
    }

    dispatchSignups(state, dispatch)
    dispatchBillings(state, dispatch)
    dispatchLeads(state, dispatch)
  }).when(({ state }) => {
    const { auth, page } = state
    return isLoggedIn(auth) && isPageReady({ page }) && isAmbassadorDetailPage(state)
  })
}

export function getAmbassadorAdminList ({ after }) {
  return after(GET_DATA_LIST, async ({ state, action, dispatch }) => {
    const { config, auth } = state
    const { storeKey, options } = action.payload

    try {
      const ambassadorAdminList = await getAmbassadorAdmins({
        auth,
        server: getConfigDataServer(config, 'auth'),
      })
      dispatch(
        setDataListAction({
          storeKey,
          options,
          records: createViewRecords(ambassadorAdminList, 'uuid'),
          total: ambassadorAdminList.get('count'),
          processing: false,
        }),
      )
    } catch (e) {
      dispatch(
        setDataListAction({
          storeKey,
          options,
          processing: false,
          error: e,
        }),
      )
    }
  }).when(
    ({ state, action }) =>
      isAmbassadorAdminAction({ action }) &&
      (isAmbassadorDetailPage(state) ||
        isAmbassadorListPage(state) ||
        isAmbassadorPayoutsPage(state)),
  )
}

export function getRelationshipOwnersList ({ after }) {
  return after(GET_DATA_LIST, async ({ state, action, dispatch }) => {
    const { config, auth } = state
    const { storeKey, options } = action.payload
    try {
      const ambassadorRelationshipOwnerList = await getAmbassadorRelationshipOwners({
        auth,
        server: getConfigDataServer(config),
      })
      dispatch(
        setDataListAction({
          storeKey,
          options,
          records: createViewRecords(ambassadorRelationshipOwnerList, 'uuid'),
          total: ambassadorRelationshipOwnerList.get('count'),
          processing: false,
        }),
      )
    } catch (e) {
      dispatch(
        setDataListAction({
          storeKey,
          options,
          processing: false,
          error: e,
        }),
      )
    }
  }).when(
    ({ state, action }) =>
      isAmbassadorRelationshipOwnerAction({ action }) &&
      (isAmbassadorListPage(state) || isAmbassadorPayoutsPage(state)),
  )
}

export function getAmbassadorDetail ({ after }) {
  return after(GET_DATA_LIST, async ({ state, action, dispatch }) => {
    const { config, auth } = state
    const { storeKey, options } = action.payload
    try {
      const ambassador = await getAmbassador({
        server: getConfigDataServer(config),
        ambassadorUuid: options.get('uuid'),
        auth,
      })
      const ambassadorList = List().push(ambassador)
      dispatch(
        setDataListAction({
          records: createViewRecords(ambassadorList, 'uuid'),
          processing: false,
          storeKey,
          options,
        }),
      )
      dispatch(
        getAmbassadorHistoryData({
          storeKey: AMBASSADOR_HISTORY_STORE_KEY,
          options: {
            uuid: options.get('uuid'),
          },
          params: {
            uuid: ambassador.get('userInfoUuid'),
          },
        }),
      )
    } catch (e) {
      dispatch(
        setDataListAction({
          processing: false,
          storeKey,
          error: e,
          options,
        }),
      )
    }
  }).when(
    ({ state, action }) => isAmbassadorDataAction({ action }) && isAmbassadorDetailPage(state),
  )
}

export function getAmbassadorDetailHistory ({ after }) {
  return after(GET_AMBASSADOR_HISTORY_DATA, async ({ state, action, dispatch }) => {
    const { config, auth } = state
    const { storeKey, options, params } = action.payload
    const { uuid } = params
    try {
      const ambassadorHistory = await getAmbassadorHistory({
        userUuid: uuid,
        ambassadorsOnly: true,
        server: getConfigDataServer(config, 'auth'),
        auth,
      })
      const historyList = ambassadorHistory.get('records', List())
      dispatch(
        setDataListAction({
          records: createViewRecords(historyList, 'id'),
          processing: false,
          storeKey,
          options,
        }),
      )
    } catch (e) {
      dispatch(
        setDataListAction({
          processing: false,
          storeKey,
          error: e,
          options,
        }),
      )
    }
  }).when(
    ({ state, action }) =>
      isAmbassadorHistoryDataAction({ action }) && isAmbassadorDetailPage(state),
  )
}

export function getAmbassadorPayoutDetail ({ after }) {
  return after(GET_DATA_LIST, async ({ state, action, dispatch }) => {
    const { config, auth } = state
    const { storeKey, options } = action.payload
    try {
      const ambassadorPayout = await getAmbassadorPayout({
        server: getConfigDataServer(config),
        ambassadorUuid: options.get('uuid'),
        startDate: options.get('startDate'),
        endDate: options.get('endDate'),
        auth,
      })
      const payoutList = ambassadorPayout.get('payouts')
      dispatch(
        setDataListAction({
          records: createViewRecords(payoutList, 'uuid'),
          processing: false,
          storeKey,
          options,
        }),
      )
    } catch (e) {
      dispatch(
        setDataListAction({
          processing: false,
          storeKey,
          error: e,
          options,
        }),
      )
    }
  }).when(
    ({ state, action }) =>
      isAmbassadorPayoutDataAction({ action }) && isAmbassadorDetailPage(state),
  )
}

export function watchGetCampaignsMetrics ({ after }) {
  return after(GET_DATA_LIST, async ({ state, action, dispatch }) => {
    const { config, auth, location } = state
    const { storeKey, options } = action.payload

    const tab = location.getIn(['data', 'query', 'tab'])
    const utmCampaign = options.get('utmCampaign')
    const ambassadorUuid = options.get('ambassadorUuid')
    const minStartDate = options.get('startDate')
    const maxStartDate = options.get('endDate')
    const sortDirection = options.get('sortDirection')
    const sortField = options.get('sortField')
    const byAmbassador = tab === CAMPAIGN_PARTNERS_TAB

    // One of the following is required
    if (!utmCampaign && !(minStartDate && maxStartDate)) {
      return
    }

    try {
      let records = await getAmbassadorCampaignsMetrics({
        server: getConfigDataServer(config),
        minStartDate,
        maxStartDate,
        utmCampaign,
        ambassadorUuid,
        byAmbassador,
        auth,
      })

      // Local sorting
      if (sortDirection && sortField) {
        const comparatorValueMapper = (item) => item.get(sortField)
        const comparator = sortDirection === SORT_ORDER_ASC ? sortASC : sortDESC
        records = records.sortBy(comparatorValueMapper, comparator)
      }

      dispatch(
        setDataListAction({
          records: createViewRecords(records, byAmbassador ? 'ambassadorUuid' : 'campaignUuid'),
          processing: false,
          storeKey,
          options,
          total: records.size,
        }),
      )
    } catch (error) {
      dispatch(showErrorToast(getFirstErrorMessage(error)))
      dispatch(
        setDataListAction({
          processing: false,
          storeKey,
          error,
          options,
        }),
      )
    }
  }).when(({ state }) => {
    const { auth, page } = state
    return isLoggedIn(auth) && isPageReady({ page }) && isAmbassadorCampaignMetricsPage(state)
  })
}

export function watchGetLeads ({ after }) {
  return after(GET_DATA_LIST, async ({ state, action, dispatch }) => {
    const { config, auth } = state
    const { storeKey, options } = action.payload

    const utmCampaign = options.get('utmCampaign')
    const campaignUuid = options.get('campaignUuid')
    const ambassadorUuid = options.get('ambassadorUuid')
    const pp = options.get('pp')
    const p = options.get('p')
    const sortDirection = options.get('sortDirection')
    const sortField = options.get('sortField')
    const minCreatedAt = options.get('minCreatedAt')
    const maxCreatedAt = options.get('maxCreatedAt')

    try {
      const response = await getAmbassadorLeads({
        pp,
        p,
        utmCampaign,
        campaignUuid,
        ambassadorUuid,
        sortDirection,
        sortField,
        minCreatedAt,
        maxCreatedAt,
        server: getConfigDataServer(config),
        auth,
      })

      dispatch(
        setDataListAction({
          records: createViewRecords(response.get('leads', List()), 'uuid'),
          processing: false,
          storeKey,
          options,
          total: response.get('count', 0),
        }),
      )
    } catch (error) {
      dispatch(showErrorToast(getFirstErrorMessage(error)))
      dispatch(
        setDataListAction({
          processing: false,
          storeKey,
          error,
          options,
        }),
      )
    }
  }).when(({ action }) => isLeadsDataAction({ action }))
}

export function downloadLeadsCSV ({ after }) {
  return after(EXPORT_AMBASSADOR_LEADS_CSV, async ({ state, dispatch }) => {
    const { config, auth, location, data: stateData } = state

    const options = createAmbassadorLeadsViewOptions(state)
    const utmCampaign = options.get('utmCampaign')
    const campaignUuid = options.get('campaignUuid')
    const ambassadorUuid = options.get('ambassadorUuid')
    const minCreatedAt = options.get('minCreatedAt')
    const maxCreatedAt = options.get('maxCreatedAt')

    const year = location.getIn(['data', 'query', 'year'], currentYear)
    const month = location.getIn(['data', 'query', 'month'])

    const name =
      stateData.getIn([AMBASSADOR_STORE_KEY, 'records', ambassadorUuid, 'name']) || utmCampaign
    const totalRows = stateData.getIn([AMBASSADOR_LEADS_STORE_KEY, 'views', 0, 'total'], 100)

    const csvTitleLeads = getCsvTitle({
      name,
      type: 'Leads',
      month,
      year,
    })

    const storeKey = AMBASSADOR_LEADS_STORE_KEY

    dispatch(
      setDataApplicationByKey({
        storeKey,
        applicationData: fromJS({ processing: true, error: null }),
        applicationKey: AMBASSADOR_LEADS_CSV_APPLICATION_KEY,
      }),
    )

    try {
      const response = await getAmbassadorLeads({
        utmCampaign,
        campaignUuid,
        ambassadorUuid,
        minCreatedAt,
        maxCreatedAt,
        pageResults: true,
        server: getConfigDataServer(config),
        auth,
        pp: totalRows,
      })

      const leads = response.get('leads', List())

      const headers = {
        [LEAD_FIELD_NAME]: 'Lead',
        [LEAD_REFERRING_PARTNER]: 'Referring Partner',
        [LEAD_CAPTURE_DATE]: 'Capture Date',
        [LEAD_CONVERTED]: 'Converted',
        [LEAD_CONVERSION_DATE]: 'Conversion Date',
        [LEAD_CAMPAIGN]: 'Campaign',
      }

      const csvData = leads
        .map((lead) => {
          const { timeZone } = Intl.DateTimeFormat().resolvedOptions()

          const createdAt = lead.get(LEAD_CAPTURE_DATE) || ''
          const conversionDate = lead.get(LEAD_CONVERSION_DATE) || ''

          return {
            [LEAD_FIELD_NAME]: lead.get(LEAD_FIELD_NAME) || '--',
            [LEAD_REFERRING_PARTNER]: lead.getIn([LEAD_REFERRING_PARTNER, 'name']),
            [LEAD_CAPTURE_DATE]: createdAt
              ? formatInTimeZone(createdAt, timeZone, 'MMM dd yyyy')
              : '--',
            [LEAD_CONVERTED]: conversionDate ? 'Yes' : 'No',
            [LEAD_CONVERSION_DATE]: conversionDate
              ? formatInTimeZone(conversionDate, timeZone, 'MMM dd yyyy')
              : '--',
            [LEAD_CAMPAIGN]: lead.getIn([LEAD_CAMPAIGN, 'name']) || '--',
          }
        })
        .toJS()

      if (utmCampaign) {
        delete headers[LEAD_CAMPAIGN]
        csvData.forEach((data) => {
          // eslint-disable-next-line no-param-reassign
          delete data[LEAD_CAMPAIGN]
        })
      }

      if (ambassadorUuid) {
        delete headers[LEAD_REFERRING_PARTNER]
        csvData.forEach((data) => {
          // eslint-disable-next-line no-param-reassign
          delete data[LEAD_REFERRING_PARTNER]
        })
      }

      dispatch(
        setDataApplicationByKey({
          storeKey,
          applicationData: fromJS({
            processing: false,
            data: {
              formattedCSVData: csvData,
            },
          }),
          applicationKey: AMBASSADOR_LEADS_CSV_APPLICATION_KEY,
        }),
      )

      exportCSVFile(headers, csvData, csvTitleLeads)
    } catch (error) {
      dispatch(
        setDataApplicationByKey({
          storeKey,
          applicationData: fromJS({
            processing: false,
            data: {},
            error,
          }),
          applicationKey: AMBASSADOR_LEADS_CSV_APPLICATION_KEY,
        }),
      )
    }
  }).when(({ state }) => {
    const { auth, page } = state

    return isLoggedIn(auth) && isPageReady({ page }) && isLeadsTab(state)
  })
}

export function watchGetAmbassadorSignups ({ after }) {
  return after(GET_DATA_LIST, async ({ state, action, dispatch }) => {
    const { config, auth } = state
    const { storeKey, options } = action.payload
    const uuid = options.get('uuid')
    try {
      const response = await getAmbassadorSignups({
        server: getConfigDataServer(config),
        uuids: uuid ? [uuid] : undefined,
        startDate: options.get('startDate'),
        endDate: options.get('endDate'),
        pp: options.get('pp', 25),
        p: options.get('p', 1),
        utmCampaign: options.get('utmCampaign'),
        auth,
      })
      const records = response.get('data', List())
      const total = response.get('total', records.size)
      dispatch(
        setDataListAction({
          records: createViewRecords(records, 'id'),
          processing: false,
          storeKey,
          options,
          total,
        }),
      )
    } catch (error) {
      dispatch(showErrorToast(getFirstErrorMessage(error)))
      dispatch(
        setDataListAction({
          processing: false,
          storeKey,
          error,
          options,
        }),
      )
    }
  }).when(({ action }) => isAmbassadorSignupsDataAction({ action }))
}

export function watchGetAmbassadorConversions ({ after }) {
  return after(GET_DATA_LIST, async ({ state, action, dispatch }) => {
    const { config, auth } = state
    const { storeKey, options } = action.payload
    const uuid = options.get('uuid')
    try {
      const response = await getAmbassadorConversions({
        server: getConfigDataServer(config),
        uuids: uuid ? [uuid] : undefined,
        startDate: options.get('startDate'),
        endDate: options.get('endDate'),
        utmCampaign: options.get('utmCampaign'),
        pp: options.get('pp', 25),
        p: options.get('p', 1),
        auth,
      })
      const records = response.get('data', List())
      const total = response.get('total', records.size)
      dispatch(
        setDataListAction({
          records: createViewRecords(records, 'id'),
          processing: false,
          storeKey,
          options,
          total,
        }),
      )
    } catch (e) {
      dispatch(
        setDataListAction({
          processing: false,
          storeKey,
          error: e,
          options,
        }),
      )
    }
  }).when(({ action }) => isAmbassadorConversionsDataAction({ action }))
}

export function watchGetAmbassadorCampaignDetails ({ after }) {
  return after([SET_LOCATION_DATA, GET_CAMPAIGN_DETAIL_DATA], async ({ state, dispatch }) => {
    const { config, auth, location } = state
    const utmCampaign = Map.isMap(location)
      ? location.getIn(['data', 'query', 'utmCampaign'], null)
      : null
    const storeKey = AMBASSADOR_CAMPAIGN_DETAILS_STORE_KEY

    if (utmCampaign) {
      try {
        const records = await getAmbassadorCampaignDetails({
          server: getConfigDataServer(config),
          utmCampaign,
          auth,
        })

        dispatch(
          setDataListAction({
            storeKey,
            options: {},
            records,
            total: records.size,
            processing: false,
          }),
        )
        dispatch(
          getDataListAction({
            storeKey: AMBASSADOR_CAMPAIGNS_STORE_KEY,
            options: createAmbassadorCampaignsOptions({ location }),
            processing: true,
            total: 0,
          }),
        )
        dispatchSignups(state, dispatch)
        dispatchBillings(state, dispatch)
        dispatchLeads(state, dispatch)
      } catch (error) {
        dispatch(showErrorToast(getFirstErrorMessage(error)))
        dispatch(
          setDataListAction({
            processing: false,
            storeKey,
            error,
            options: {},
          }),
        )
      }
    }
  }).when(({ state }) => {
    const { auth, page } = state
    return isLoggedIn(auth) && isPageReady({ page }) && isAmbassadorCampaignDetailPage(state)
  })
}

// ------------------------
// Monthly Payouts
// ------------------------
export function initAmbassadorPayoutsPage ({ after }) {
  return after(
    [SET_AUTH_DATA, SET_PAGE_READY, SET_LOCATION_DATA],
    async ({ state, prevState, dispatch }) => {
      const { data } = state
      const storeKey = AMBASSADOR_PAYOUTS_STORE_KEY
      const options = createAmbassadorPayoutsPageOptions(state)
      const prevOptions = createAmbassadorPayoutsPageOptions(prevState)
      const view = findView({ data, storeKey, options })
      const ambassadorPayoutsReady = view && options.equals(prevOptions)
      const adminsReady = data.get(AMBASSADOR_ADMIN_STORE_KEY)

      if (ambassadorPayoutsReady && adminsReady) {
        return
      }
      // Monthly Payouts
      dispatch(
        getDataListAction({
          storeKey,
          options,
        }),
      )
      dispatch(
        getDataListAction({
          storeKey: AMBASSADOR_ADMIN_STORE_KEY,
          options: {},
        }),
      )

      dispatch(
        getDataListAction({
          storeKey: AMBASSADOR_RELATIONSHIP_OWNER_STORE_KEY,
          options: {},
        }),
      )
    },
  ).when(({ state }) => {
    const { auth, page } = state
    return isLoggedIn(auth) && isPageReady({ page }) && isAmbassadorPayoutsPage(state)
  })
}

export function fetchAmbassadorPayouts ({ after }) {
  return after(GET_DATA_LIST, async ({ state, action, dispatch }) => {
    const { auth, config } = state
    const { storeKey, options } = action.payload
    try {
      const payoutList = await getAmbassadorPayouts({
        auth,
        startDate: options.get('startDate'),
        endDate: options.get('endDate'),
        server: getConfigDataServer(config),
        page: options.get('page'),
        perPage: options.get('perPage'),
        sortField: options.get('sortField'),
        sortDirection: options.get('sortDirection'),
        name: options.get('name'),
        businessName: options.get('businessName'),
        utmMedium: options.get('utmMedium'),
        contactEmail: options.get('contactEmail'),
        gaiaEmail: options.get('gaiaEmail'),
        relationshipOwnerUuid: options.get('relationshipOwnerUuid'),
        parentUtm: options.get('parentUtm'),
      })
      const payouts = payoutList.get('payouts')
      const total = payoutList.get('total')
      const records = createViewRecords(payouts, 'uuid')
      dispatch(
        setDataListAction({
          storeKey,
          options,
          records,
          total,
          processing: false,
        }),
      )
    } catch (e) {
      dispatch(
        setDataListAction({
          storeKey,
          options,
          processing: false,
          error: e,
        }),
      )
    }

    // Get payout totals
    dispatch(
      setDataApplicationByKey({
        storeKey,
        applicationData: fromJS({ processing: true }),
        applicationKey: AMBASSADOR_PAYOUT_TOTALS_APPLICATION_KEY,
      }),
    )
    try {
      const totals = await getAmbassadorPayoutTotals({
        auth,
        startDate: options.get('startDate'),
        endDate: options.get('endDate'),
        server: getConfigDataServer(config),
      })
      dispatch(
        setDataApplicationByKey({
          storeKey,
          applicationData: fromJS({ processing: false, data: totals }),
          applicationKey: AMBASSADOR_PAYOUT_TOTALS_APPLICATION_KEY,
        }),
      )
    } catch (e) {
      dispatch(
        setDataApplicationByKey({
          storeKey,
          applicationData: fromJS({
            processing: false,
            data: {},
            error: e,
          }),
          applicationKey: AMBASSADOR_PAYOUT_TOTALS_APPLICATION_KEY,
        }),
      )
    }
  }).when(
    ({ state, action }) =>
      isAmbassadorPayoutsDataAction({ action }) && isAmbassadorPayoutsPage(state),
  )
}

// Download CSV - Monthly Payout
export function downloadAmbassadorMonthlyPayoutCSV ({ after }) {
  return after([EXPORT_AMBASSADORS_PAYOUT_CSV], async ({ state, dispatch }) => {
    const { auth, config } = state
    const options = createAmbassadorPayoutsPageOptions(state)
    const storeKey = AMBASSADOR_PAYOUTS_STORE_KEY

    try {
      dispatch(
        setDataApplicationByKey({
          storeKey,
          applicationData: fromJS({ processing: true, error: null }),
          applicationKey: AMBASSADOR_PAYOUTS_CSV_APPLICATION_KEY,
        }),
      )

      const payoutsList = await getAmbassadorPayouts({
        auth,
        startDate: options.get('startDate'),
        endDate: options.get('endDate'),
        server: getConfigDataServer(config),
        sortField: options.get('sortField'),
        sortDirection: options.get('sortDirection'),
        name: options.get('name'),
        businessName: options.get('businessName'),
        utmMedium: options.get('utmMedium'),
        contactEmail: options.get('contactEmail'),
        relationshipOwnerUuid: options.get('relationshipOwnerUuid'),
        parentUtm: options.get('parentUtm'),
        pageResults: false,
      })

      const title = `Partner-Monthly-Payouts-${formatWrapped(new Date(), 'yyyy-MM-dd')}`
      const headers = {
        businessName: 'Business Name',
        name: 'Name',
        email: 'RFD Email',
        utmMedium: 'UTM Medium',
        ripple1Percentage: 'Partner Commission %',
        ripple2Percentage: 'Referral Commission %',
        unpaidFromPreviousMonth: 'Unpaid From Previous Month(s)',
        ripple1UtmPayout: 'Partner UTM Payout',
        ripple1ReferralPayout: 'Partner RFD Payout',
        ripple2UtmPayout: 'Referral UTM Payout',
        ripple2ReferralPayout: 'Referral RFD Payout',
        totalEarned: 'Total Earned (Current Month)',
        total: 'Total (Total Earned + Unpaid from Previous)',
        totalPayout: 'Total Payout (Current Month)',
        totalUnpaid: 'Total Remaining Unpaid',
        ambassadorIsActive: 'Active',
        relationshipOwner: 'Relationship Owner',
        parentUtm: 'Referring Partner',
      }

      const csvData = payoutsList
        .get('payouts')
        .map((po) => ({
          businessName: stripComma(po.getIn(['ambassador', 'businessName']) || '--'),
          name: stripComma(po.getIn(['ambassador', 'name']) || '--'),
          email: stripComma(po.getIn(['ambassador', 'gaiaEmail']) || '--'),
          utmMedium: stripComma(po.getIn(['ambassador', 'utmMedium']) || '--'),
          ripple1Percentage: po.get('ripple1Percentage', 0),
          ripple2Percentage: po.get('ripple2Percentage', 0),
          unpaidFromPreviousMonth: getCSVNumberValue(po.get('unpaidFromPreviousMonthUSD')),
          ripple1UtmPayout: getCSVNumberValue(po.get('ripple1UtmPayoutUSD')),
          ripple1ReferralPayout: getCSVNumberValue(po.get('ripple1ReferralPayoutUSD')),
          ripple2UtmPayout: getCSVNumberValue(po.get('ripple2UtmPayoutUSD')),
          ripple2ReferralPayout: getCSVNumberValue(po.get('ripple2ReferralPayoutUSD')),
          totalEarned: getCSVNumberValue(po.get('currentMonthCommissionUSD')),
          total: getCSVNumberValue(po.get('totalPayoutUSD') + po.get('totalUnpaidUSD')),
          totalPayout: getCSVNumberValue(po.get('totalPayoutUSD')),
          totalUnpaid: getCSVNumberValue(po.get('totalUnpaidUSD')),
          ambassadorIsActive: po.get('ambassadorIsActive') ? 'Yes' : 'No',
          relationshipOwner: po.get('relationshipOwner', 'Unassigned'),
          parentUtm: po.get('parentUtm', ''),
        }))
        .toJS()

      dispatch(
        setDataApplicationByKey({
          storeKey,
          applicationData: fromJS({
            processing: false,
            data: {
              formattedCSVData: csvData,
            },
          }),
          applicationKey: AMBASSADOR_PAYOUTS_CSV_APPLICATION_KEY,
        }),
      )
      exportCSVFile(headers, csvData, title)
    } catch (e) {
      dispatch(
        setDataApplicationByKey({
          storeKey,
          applicationData: fromJS({
            processing: true,
            data: {},
            error: e,
          }),
          applicationKey: AMBASSADOR_PAYOUTS_CSV_APPLICATION_KEY,
        }),
      )
    }
  }).when(({ state }) => {
    const { auth, page } = state
    return isLoggedIn(auth) && isPageReady({ page }) && isAmbassadorPayoutsPage(state)
  })
}

// Download CSV - Ambassador List
export function downloadAmbassadorsCSV ({ after }) {
  return after([EXPORT_AMBASSADOR_LIST_CSV], async ({ state, dispatch }) => {
    const { auth, config } = state
    const storeKey = AMBASSADOR_STORE_KEY

    try {
      dispatch(
        setDataApplicationByKey({
          storeKey,
          applicationData: fromJS({ processing: true, error: null }),
          applicationKey: AMBASSADOR_LIST_CSV_APPLICATION_KEY,
        }),
      )

      const ambassadorList = await getAmbassadorList({
        auth,
        server: getConfigDataServer(config),
        sortField: AMBASSADOR_FIELD_NAME,
        sortDirection: SORT_ORDER_ASC,
        pageResults: false,
      })

      const title = `Partner-List-${formatWrapped(new Date(), 'yyyy-MM-dd')}`
      const headers = {
        name: 'Name',
        businessName: 'Business Name',
        relationship: 'Relationship',
        contactEmail: 'Contact Email',
        rfdEmail: 'RFD Email',
        startDate: 'Start Date',
        utmMedium: 'UTM Medium',
        ripple1Percentage: 'Partner Commission %',
        ripple2Percentage: 'Referral Commission %',
        relationshipOwner: 'Relationship Owner',
        status: 'Status',
        country: 'Country',
        payoutCurrency: 'Payout Currency',
        parentUtm: 'Referring Partner',
        referralId: 'Referral ID',
      }

      const csvData = ambassadorList
        .get('ambassadors')
        .map((ambassador) => ({
          name: stripComma(ambassador.get('name', '') || '--'),
          businessName: stripComma(ambassador.get('businessName', '') || '--'),
          relationship: stripComma(ambassador.get('relationship', '') || '--'),
          contactEmail: stripComma(ambassador.get('contactEmail', '') || '--'),
          rfdEmail: stripComma(ambassador.get('gaiaEmail', '') || '--'),
          startDate: formatWrapped(parseISO(ambassador.get('createdAt')), 'yyyy-MM-dd'),
          utmMedium: stripComma(ambassador.get('utmMedium', '') || '--'),
          ripple1Percentage: ambassador.get('ripple1Percentage', 0),
          ripple2Percentage: ambassador.get('ripple2Percentage', 0),
          relationshipOwner:
            ambassador.getIn(['relationshipOwner', 'fullName'], '') || 'Unassigned',
          status: ambassador.get('isActive', false) ? 'Active' : 'Inactive',
          country: ambassador.get('residenceCountry', '') || '--',
          payoutCurrency: ambassador.get('payoutCurrency', '') || '--',
          parentUtm: ambassador.getIn(['parentAmbassador', 'utmMedium'], '') || '--',
          referralId: ambassador.get('referralId', '') || '--',
        }))
        .toJS()

      dispatch(
        setDataApplicationByKey({
          storeKey,
          applicationData: fromJS({
            processing: false,
            data: {
              formattedCSVData: csvData,
            },
          }),
          applicationKey: AMBASSADOR_LIST_CSV_APPLICATION_KEY,
        }),
      )
      exportCSVFile(headers, csvData, title)
    } catch (e) {
      dispatch(
        setDataApplicationByKey({
          storeKey,
          applicationData: fromJS({
            processing: true,
            data: {},
            error: e,
          }),
          applicationKey: AMBASSADOR_LIST_CSV_APPLICATION_KEY,
        }),
      )
    }
  }).when(({ state }) => {
    const { auth, page } = state
    return isLoggedIn(auth) && isPageReady({ page }) && isAmbassadorListPage(state)
  })
}

// helper fn for constructing signups and billings titles
function getCsvTitle ({ name, type, month, year }) {
  let title
  const date = formatWrapped(new Date(), 'yyyy-MM-dd')
  title = name ? name.replace(/\s+/g, '') : 'Master'
  title = month ? `${title}-${type}-${year}-${month}` : `${title}-${type}-${year}-All`
  title = `${title}_Downloaded-${date}`
  return title
}

// Download CSV - Ambassador Signups
export function downloadAmbassadorSignupsCSV ({ after }) {
  return after([EXPORT_AMBASSADOR_SIGNUPS_CSV], async ({ state, dispatch }) => {
    const { auth, config, location, data } = state
    const storeKey = AMBASSADOR_SIGNUPS_STORE_KEY
    const getPlan = (record) => {
      const contentSetId = record.get('planContentSetId', 0)
      return subscripitonNameFromContentSetId(contentSetId)
    }

    try {
      dispatch(
        setDataApplicationByKey({
          storeKey,
          applicationData: fromJS({ processing: true, error: null }),
          applicationKey: AMBASSADOR_SIGNUPS_CSV_APPLICATION_KEY,
        }),
      )
      const options = createAmbassadorSignupOptions({ location })
      const view = findView({ data, storeKey, options })
      const total = view.get('total')
      if (total > AMBASSADOR_MAX_CSV_RECORDS) {
        alert(`Datasets with over ${AMBASSADOR_MAX_CSV_RECORDS} are too large to export`)
        return
      }
      const pages = Math.ceil(total / AMBASSADOR_CSV_BATCH_SIZE)
      const ambassadorsSignups = await BluebirdReduce(
        _range(1, pages + 1),
        async (acc, p) => {
          const res = await getAmbassadorSignups({
            server: getConfigDataServer(config),
            uuids: options.get('uuid') ? [options.get('uuid')] : undefined,
            startDate: options.get('startDate'),
            endDate: options.get('endDate'),
            pp: AMBASSADOR_CSV_BATCH_SIZE,
            p,
            utmCampaign: options.get('utmCampaign'),
            auth,
          })
          return acc.concat(...res.get('data'))
        },
        [],
      )

      // title
      const uuid = location.getIn(['data', 'query', 'uuid'])
      const month = location.getIn(['data', 'query', 'month'])
      const year = location.getIn(['data', 'query', 'year'])
      const utmCampaign = location.getIn(['data', 'query', 'utmCampaign'])
      const name = data.getIn(['ambassador', 'records', uuid, 'name']) || utmCampaign
      const csvTitleSignups = getCsvTitle({
        name,
        type: 'Signups',
        month,
        year,
      })
      const csvHeadersSignups = {
        date: 'Date',
        ambasador: 'Partner',
        ambassadorUtm: 'Partner UTM',
        member: 'Member',
        memberEmail: 'Member Email',
        plan: 'Plan',
        planDetails: 'Plan Details',
        event: 'Event',
        campaign: 'Campaign',
        source: 'Signup Source',
        medium: 'Source ID',
      }
      const records = fromJS(ambassadorsSignups)
      const csvDataSignups = records
        .map((record) => ({
          date: stripComma(formatUTC(record.get('createdAt'))),
          ambassador:
            record.getIn(['ambassador', 'fullName']) || record.getIn(['ambassador', 'username']),
          ambassadorUtm: record.getIn(['ambassador', 'utmMedium']),
          member: record.getIn(['member', 'fullName']) || record.getIn(['member', 'username']),
          memberEmail: record.getIn(['member', 'email']),
          plan: getPlan(record),
          planDetails: record.get('planName') || 'N/A',
          event: record.get('triggerEvent') || 'N/A',
          campaign: record.getIn(['campaign', 'campaignName']) || 'N/A',
          source:
            record.get('source') === 'RFD'
              ? `${record.get('source')}: ${record.get('sourceDetails')}`
              : record.get('source'),
          medium: record.get('medium'),
        }))
        .toJS()
      dispatch(
        setDataApplicationByKey({
          storeKey,
          applicationData: fromJS({
            processing: false,
          }),
          applicationKey: AMBASSADOR_SIGNUPS_CSV_APPLICATION_KEY,
        }),
      )
      exportCSVFile(csvHeadersSignups, csvDataSignups, csvTitleSignups)
    } catch (e) {
      dispatch(
        setDataApplicationByKey({
          storeKey,
          applicationData: fromJS({
            processing: false,
            error: e,
          }),
          applicationKey: AMBASSADOR_SIGNUPS_CSV_APPLICATION_KEY,
        }),
      )
    }
  }).when(({ state }) => {
    const { auth, page } = state
    return isLoggedIn(auth) && isPageReady({ page }) && isSignupsTab(state)
  })
}

function subscripitonNameFromContentSetId (contentSetId) {
  // TO-DO REMOVE AFTER EMERSION, THIS VALIDATION IS VALID FOR ENABLE AUTOMATICALLY
  const currentTime = new Date().getTime()
  const enableTime = new Date('2024-03-15').getTime()
  switch (contentSetId) {
    case 200:
      return 'AI Only'
    case 290:
      return currentTime > enableTime ? 'Events+' : 'Gaia+'
    case 280:
      return 'Annual'
    case 253:
      return 'Monthly'
    default:
      return 'N/A'
  }
}

// Download CSV - Ambassador Conversions
export function downloadAmbassadorConversionsCSV ({ after }) {
  return after([EXPORT_AMBASSADOR_CONVERSIONS_CSV], async ({ state, dispatch }) => {
    const { auth, config, location, data } = state
    const storeKey = AMBASSADOR_CONVERSIONS_STORE_KEY
    const getPlan = (record) => {
      const contentSetId = record.get('planContentSetId', 0)
      return subscripitonNameFromContentSetId(contentSetId)
    }

    try {
      dispatch(
        setDataApplicationByKey({
          storeKey,
          applicationData: fromJS({ processing: true, error: null }),
          applicationKey: AMBASSADOR_CONVERSIONS_CSV_APPLICATION_KEY,
        }),
      )

      const options = createAmbassadorConversionsOptions({ location })
      const view = findView({ data, storeKey, options })
      const total = view.get('total')
      if (total > AMBASSADOR_MAX_CSV_RECORDS) {
        alert(`Datasets with over ${AMBASSADOR_MAX_CSV_RECORDS} are too large to export`)
        return
      }
      const pages = Math.ceil(total / AMBASSADOR_CSV_BATCH_SIZE)
      const ambassadorsConversions = await BluebirdReduce(
        _range(1, pages + 1),
        async (acc, p) => {
          const res = await getAmbassadorConversions({
            server: getConfigDataServer(config),
            uuids: options.get('uuid') ? [options.get('uuid')] : undefined,
            startDate: options.get('startDate'),
            endDate: options.get('endDate'),
            utmCampaign: options.get('utmCampaign'),
            pp: AMBASSADOR_CSV_BATCH_SIZE,
            p,
            auth,
          })
          return acc.concat(...res.get('data'))
        },
        [],
      )

      // title
      const uuid = location.getIn(['data', 'query', 'uuid'])
      const month = location.getIn(['data', 'query', 'month'])
      const year = location.getIn(['data', 'query', 'year'])
      const utmCampaign = location.getIn(['data', 'query', 'utmCampaign'])
      const name = data.getIn(['ambassador', 'records', uuid, 'name']) || utmCampaign
      const csvTitleConversions = getCsvTitle({
        name,
        type: 'Billings',
        month,
        year,
      })
      const csvHeadersConversions = {
        date: 'Date',
        ambassador: 'Partner',
        ambassadorUtm: 'Partner UTM',
        member: 'Member',
        memberEmail: 'Member Email',
        plan: 'Plan',
        planDetails: 'Plan Details',
        event: 'Event',
        campaign: 'Campaign',
        payment: 'Payment',
        currency: 'Currency',
        signupSource: 'Source',
        signupMedium: 'Source ID',
        paymentStatus: 'Payment Status',
        txnDate: 'Transaction Date',
        txnId: 'Transaction ID',
      }
      const records = fromJS(ambassadorsConversions)
      const csvDataConversions = records
        .map((record) => ({
          date: stripComma(formatUTC(record.get('createdAt'))),
          ambassador:
            record.getIn(['ambassador', 'fullName']) || record.getIn(['ambassador', 'username']),
          ambassadorUtm: record.getIn(['ambassador', 'utmMedium']),
          member: record.getIn(['member', 'fullName']) || record.getIn(['member', 'username']),
          memberEmail: record.getIn(['member', 'email']),
          plan: getPlan(record),
          planDetails: record.get('planName') || 'N/A',
          event: record.get('triggerEvent') || 'N/A',
          campaign: record.getIn(['campaign', 'campaignName']) || 'N/A',
          payment: getCSVNumberValue(record.get('paymentAmount')),
          currency: record.get('paymentCurrency'),
          signupSource:
            record.get('source') === 'RFD'
              ? `${record.get('source')}: ${record.get('sourceDetails')}`
              : record.get('source'),
          signupMedium: record.get('medium'),
          paymentStatus: record.get('rewardFulfilled') ? 'Payment Completed' : 'Payment Scheduled',
          txnDate: stripComma(formatWrapped(parseISO(record.get('txnDate')), 'MMM d, yyyy')),
          txnId: record.get('txnId'),
        }))
        .toJS()
      dispatch(
        setDataApplicationByKey({
          storeKey,
          applicationData: fromJS({
            processing: false,
          }),
          applicationKey: AMBASSADOR_CONVERSIONS_CSV_APPLICATION_KEY,
        }),
      )
      exportCSVFile(csvHeadersConversions, csvDataConversions, csvTitleConversions)
    } catch (e) {
      dispatch(
        setDataApplicationByKey({
          storeKey,
          applicationData: fromJS({
            processing: false,
            error: e,
          }),
          applicationKey: AMBASSADOR_CONVERSIONS_CSV_APPLICATION_KEY,
        }),
      )
    }
  }).when(({ state }) => {
    const { auth, page } = state
    return isLoggedIn(auth) && isPageReady({ page }) && isBillingsTab(state)
  })
}
